
(function() {
    'use strict';
    window.addEventListener('load', function() {
      // fetch all the forms we want to apply custom style
      var inputs = document.getElementsByClassName('form-control')
  
      // loop over each input and watch blur event
      var validation = Array.prototype.filter.call(inputs, function(input) {
  
        input.addEventListener('blur', function(event) {
          // reset
          input.classList.remove('is-invalid')
          input.classList.remove('is-valid')
  
          if (input.checkValidity() === false) {
              input.classList.add('is-invalid')
          }
          else {
              input.classList.add('is-valid')
          }
        }, false);
      });
  
  
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.getElementsByClassName('needs-validation');
                  // Loop over them and prevent submission
                  var validation = Array.prototype.filter.call(forms, function(form) {
                      form.addEventListener('submit', function(event) {
                          if (form.checkValidity() === false) {
                              event.preventDefault();
                              event.stopPropagation();
                           }
                           else {
                              event.preventDefault();
                              event.stopPropagation();
                              console.log('In here');
                           //   alert('in');
                           vm.submitForm(event);
                           }
                          
                          form.classList.add('was-validated');
                      }, false);
                  });
  
    }, false);
  
  })()
  
      Vue.component('validation-errors', {
          data(){
              return {
                  
              }
          },
          props: ['errors'],
          template: `<div v-if="validationErrors">
                      <ul class="alert alert-danger">
                          <li v-for="(value, key, index) in validationErrors">@{{ value }}</li>
                      </ul>
                  </div>`,
          computed: {
              validationErrors(){
                  let errors = Object.values(this.errors);
                  errors = errors.flat();
                  return errors;
              }
          }
      });
    let vm = new Vue({
       el: "#contact-form",
       data: {
        fname: '',
        lname: '',
        email: '',
        phone: '',
        postcode: '',
        adi: '',
        message: '',
        validationErrors: '',
        validationSuccess: ''
       },
       methods: {
        submitForm(){
          console.log('submitting');
         axios.post('/contact', {
          fname: this.fname,
          lname: this.lname,
          phone: this.phone,
          postcode: this.postcode,
          email: this.email,
          adi: this.adi,
          message: this.message
         }).then(response => {
          console.log('successful');
          this.validationErrors='';
          this.validationSuccess=response.data;
       //   document.getElementById('messagess').scrollIntoView();
       //   $('#requestModal',this.$el).modal('show');
       window.location.href ="/thank-you";
         }).catch(error => {
          if (error.response.status == 422){
           this.validationSuccess='';
           this.validationErrors = error.response.data.errors;
           document.getElementById('messagess').scrollIntoView();
  
          }
         })
        }
       }
      })
  
  